import React, { useState, useEffect } from 'react'
import { IoCalendarClearOutline } from "react-icons/io5";
import { FiDownload, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Dropdown } from 'react-bootstrap';

import event from "../../../images/icon/events.svg"
import { PiUserCircleLight } from "react-icons/pi";
import { GrLocation } from "react-icons/gr";
import { HiOutlineEnvelope } from "react-icons/hi2";
import Pagination from '../../Common/Pagination';
import { FaSpinner } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FetchAdminPayOut } from '../../../Redux/Actions/AdminPayOutAction';
import NewPagination from '../../Common/NewPagination';
const AllEarnings = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const userId = location?.state?.slug
    const [filteredData, setFilteredData] = useState([])
    const [data, setData] = useState({})
    const [loader, setLoader] = useState({
        fetch: true
    })
    const [currentPage, setCurrentPage] = useState(1);


    const fetchdata = () => {
        setLoader({
            ...loader,
            fetch: true
        })
        let formData = {
            "page": currentPage || 1,
            "userId": userId
        }
        dispatch(FetchAdminPayOut("admin-user-wallethistory", formData, loader, setLoader, setData))
    }
    const handlePageChange = (page) => {
        setCurrentPage(page);
    }
    useEffect(() => {

        if (data.list) {
            setFilteredData(data.list);


        }
        else {
            setFilteredData([]);
        }
    }, [data]);

    useEffect(() => {
        if (userId) {
            fetchdata()
        }
        else {
            setFilteredData([])
        }

    }, [currentPage, userId])

    return (
        <>
            {
                loader.fetch ? <div className="d-flex align-items-center justify-content-center mt-4"><FaSpinner className="spin ms-1" style={{ fontSize: "40px" }} /></div> :
                    <>
                        <div className="account-block mt-4">

                            <div className='d-flex align-items-center justify-content-between'>
                                <h6>All Earnings</h6>

                            </div>

                            <div className='table-responsive mt-4'>
                                <table className="table theme-table">
                                    <thead>
                                        <tr>
                                            <th>Task ID</th>
                                            <th>Task Title</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Status</th>

                                            {/* <th>Invoice</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData.length > 0 ? filteredData.map((curElem, i) => {
                                            return (<tr key={i}>
                                                <td data-label="Task ID">{curElem.id}</td>
                                                <td data-label="Task Title">{curElem.title}</td>
                                                <td data-label="Date"><img src={event} alt="" />{curElem.created_at}</td>
                                                <td data-label="Amount">{curElem.amount} point</td>


                                                <td data-label="Status"><span className="table-stat active">{curElem.mode}</span></td>
                                            </tr>)
                                        }) :
                                            <td className='text-center pt-3' colspan={7}>No taskers Data</td>
                                        }
                                    </tbody>
                                </table>
                                <div className='d-flex justify-content-end my-4'>
                                    <NewPagination
                                        currentPage={currentPage}
                                        handlePageChange={handlePageChange}
                                        data={filteredData}
                                        loader={loader.fetch}
                                    />
                                </div>



                            </div>
                        </div>
                    </>
            }
        </>

    )
}

export default AllEarnings